import type { SortKey } from '@/lib/videos';

interface SortTabsProps {
  value: SortKey;
  onChange: (value: SortKey) => void;
}

const options: { key: SortKey; label: string }[] = [
  { key: 'latest', label: '最新上传' },
  { key: 'popular', label: '最多观看' },
  { key: 'duration', label: '时长最长' },
];

export default function SortTabs({ value, onChange }: SortTabsProps) {
  return (
    <div className="flex items-center gap-1 rounded-full bg-background-100 px-1 py-1">
      {options.map((option) => (
        <button
          key={option.key}
          type="button"
          onClick={() => onChange(option.key)}
          className={`h-8 cursor-pointer whitespace-nowrap rounded-full px-3 text-[12px] transition-colors ${
            value === option.key
              ? 'bg-background-50 text-primary-700'
              : 'text-foreground-500 hover:text-foreground-800'
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}